import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Status } from '@bcef/ia-shared';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, tap } from 'rxjs';

import * as fromStore from '@features/termination/store';

export const canActivate: CanActivateFn = () => {
  const store = inject(Store);

  return store
    .select(fromStore.selectConfigLoadStatus)
    .pipe(
      tap((status: string) => {
        if (status === Status.INITIAL) {
          store.dispatch(fromStore.ConfigLoad());
        }
      }),
    )
    .pipe(
      filter((status) => status !== Status.INITIAL),
      switchMap((status) => of(status !== Status.PROCESSING)),
    );
};
